// import $ from 'jquery';

import { initMobileMenu } from './mobile-menu';
import { paintMasonryLayout } from './masonry-layout';
import { initFancyInputBox } from './fancy-input';
import { initInfiniteScroll } from './infinite-scroll';
import { formValidationEvents } from './form/form-events';
import { initStateDropDownBox } from './state-dropdown';
import { sizePicker } from './offer-size-picker';
import { intiSwapVideo } from './swap-video';
//import { subNav } from './menu-subnav';
import { memberNav } from './member-menu';
import { tourInfoDropDown } from './tour-dropdown';
import { setlistPopup } from './setlist-popup';
import { zteamFaqPopup } from './zteam-popup';
//import { invokeFlexSlider } from './flex-slider';
//import { newsArchive } from './news-archive';
import { initCleaveDate } from './cleave-date';
//import { initTMIdentity } from './tm-login';
import { autocomplete } from './autocomplete';
// import 'slick-carousel';
// import 'slick-carousel/slick/slick.css';
// import 'slick-carousel/slick/slick-theme.css';

import 'slider-pro';

$(function() {
  initMobileMenu();
  paintMasonryLayout();
  initFancyInputBox();
  initInfiniteScroll();
  initStateDropDownBox();
  formValidationEvents();
  sizePicker();
  intiSwapVideo();
	//subNav();
	memberNav();
  tourInfoDropDown();
  setlistPopup();
  zteamFaqPopup();
  //invokeFlexSlider();
  //newsArchive();
  //initTMIdentity();
  initCleaveDate();
  autocomplete();
  //download();
  /*
  $('.js-downloadLink' ).on("click", function(e){


	  function forceDownload(blob, filename) {
		  var a = document.createElement('a');
		  a.download = filename;
		  a.href = blob;
		  a.click();
	  }

	  function downloadResource(url, filename) {
		  if (!filename) filename = url.split('\\').pop().split('/').pop();
		  fetch(url, {
		      headers: new Headers({
		        'Origin': location.origin
		      }),
		      mode: 'cors'
		    })
		    .then(response => response.blob())
		    .then(blob => {
		      let blobUrl = window.URL.createObjectURL(blob);
		      forceDownload(blobUrl, filename);
		    })
		    .catch(e => console.error(e));
		}
	  	downloadResource('https://cdn.ontourmedia.io/nkotb/non_secure/images/20171213/dsc_42211513216619/dsc_42211513216619_1024.jpg');
	  	e.preventDefault();
	  	e.stopPropagation();
  });

*/
});

/*
const download= function(){
	$('.js-downloadLink').on('click', function (e) {
		const url1= "http://nkotb2.vm704.lyv.livenation.com/cdn?image=//cdn.ontourmedia.io/nkotb/non_secure/images/20171113/2017cruise_bb_66891510620392/2017cruise_bb_66891510620392.jpg";
	    $.ajax({
	        // url: 'https://cdn.ontourmedia.io/nkotb/non_secure/images/20171213/v5_432915131300991513200813/v5_432915131300991513200813_1024.jpg',
	        url: url1, //'https://cdn.ontourmedia.io/nkotb/non_secure/images/20171113/2017cruise_bb_66891510620392/2017cruise_bb_66891510620392.jpg',
	        method: 'GET',
	        xhrFields: {
	            responseType: 'blob'
	        },
	        success: function (data) {
	          data['Content-disposition']= "attachment";
	          console.log("From 2nd ",data);
	          //const url = window.URL.createObjectURL(data);
	          //var a = document.createElement('a');
			  //a.download = 'andy2.jpg';
			  //a.href = url;
			  //a.click();

	          const reader = new FileReader();
	          reader.readAsDataURL(data);

	          //$(".js-downloadLink")[0].setAttribute("href", window.URL.createObjectURL(data));
	          //$(".js-downloadLink")[0].setAttribute("download", "nkotbchacha.jpg");
	          //$('.js-downloadLink').unbind();
	          //linkElement.click();
	          //console.log("Link Clicked V3");
	          //e.preventDefault();
	          //e.stopPropagation();


	          reader.onload = function(eee) {
	        	  console.log("Data", eee);
	        	  //const fileDownload = require('download-as-file');
	        	  //fileDownload({data: eee.target.result,filename : 'nkotb55.jpg'});
	        	  //console.log("Download complete");
	        	  //return false;
	              // browser completed reading file - display it
	              //console.log("Img value is",eee);

		          //const linkElement = document.createElement('a');
		          //document.body.appendChild(linkElement);
		          //$('.downloadGallery').append(linkElement);

		         // linkElement.download = 'ccc3.jpg';
		          //linkElement.href = eee.target.result;

	          	  //console.log($(".pageContainer--fullPagePhotoContent img"));

	        	// some data to export

		          $(".js-downloadLink")[0].setAttribute("href", eee.target.result);
		          $(".js-downloadLink")[0].setAttribute("download", "nkotbchacha.jpg");
		          $('.js-downloadLink').unbind();
		          //linkElement.click();
		          console.log("Link Clicked V3");
		          e.preventDefault();
		          e.stopPropagation();
		          //b.target= "_self";

	          };



	          //window.URL.revokeObjectURL(url);


	          //dLink.setAttribute("href", url);
	          //dLink.setAttribute("download", 'andy.jpg');
	          //dLink.setAttribute("target", '_self');

	          //dLink.click();
	          //
	        }
	    });

	  });

}





const download2 = function(){
	$('.js-downloadLink').on('click', function (e) {
		e.preventDefault();
		const downloadLink= $(this).attr('href');
		console.log(downloadLink);

	    $.ajax({
	        url: "https://cdn.ontourmedia.io/nkotb/non_secure/images/20171113/2017cruise_bb_66891510620392/2017cruise_bb_66891510620392.jpg",
	        method: 'GET',
	        xhrFields: {
	            responseType: 'blob'
	        },
	        success: function (data) {
	          const dLink = document.createElement('a');
	          document.body.appendChild(dLink);
          	  console.log(this);
          	  console.log(data);
	          const url = window.URL.createObjectURL(data);
	          dLink.setAttribute("href", url);
	          dLink.setAttribute("download", 'andy.jpg');
	          dLink.setAttribute("target", '_self');
          	  console.log("About to click");
	          dLink.click();
	          console.log("And CLicked");
	          window.URL.revokeObjectURL(url);
	        }
	    });


	  });
}
*/
$('#sliderContent--main').sliderPro({
  width: '100%',
  //height: '400px',
  autoHeight: true,
  aspectRatio: 3,
  arrows: true,
  buttons: true,
  fade: false,
  autoplay: true,
});
